import { render, staticRenderFns } from "./flexPetzGeographic.vue?vue&type=template&id=bf3bf3ea&scoped=true"
import script from "./flexPetzGeographic.vue?vue&type=script&lang=js"
export * from "./flexPetzGeographic.vue?vue&type=script&lang=js"
import style0 from "./flexPetzGeographic.vue?vue&type=style&index=0&id=bf3bf3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3bf3ea",
  null
  
)

export default component.exports